'use strict';

require('jquery');
require('datepicker');
require('lodash');
require('moment');
require('twix');
require('d3');
require('d3-tip');
require('urijs');
require('angular');
require('numeral');
require('bootstrap');
require('@uirouter/angularjs');
require('angular-animate');
require('angular-hotkeys');
require('ng-stats');
require('restangular');
require('@sabre/sabre-avro-jqwidgets');
require('angular-q-spread');
require('angular-vs-repeat');
require('angular-checkboxes');
require('angular-wizard');
require('angular-grid');
require('angular-cookies');
require('angular-idle-service');
require('ng-idle');
require('@sabre/sabre-avro-sly');
require('toastr');
require('perfect-scrollbar');
delete window.d3;
delete window.jQuery;